import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../auth.jsx';
import { AccountMenu } from './Layout.jsx';

/** Shell for /admin: platform admins only (RequireAdmin wraps it in main.jsx). */
export default function AdminLayout() {
  const { roles } = useAuth();
  const portal = roles.includes('user');

  return (
    <div className="shell">
      <header className="topbar topbar-admin">
        <div className="topbar-inner">
          <NavLink to="/admin" className="brand"><img src="/logo.png" alt="SummitShield" width="125" height="30" /></NavLink>
          <span className="admin-badge">Admin</span>
          <nav aria-label="Admin" className="topnav">
            <NavLink to="/admin/users">Users</NavLink>
            <NavLink to="/admin/honeypot-domains">Honeypot domains</NavLink>
          </nav>
          <div className="spacer" />
          {portal && <NavLink to="/dashboard" className="topbar-link">Portal</NavLink>}
          {/* Edit profile lives in the portal, so it's offered only to admins who use it */}
          <AccountMenu profile={portal} />
        </div>
      </header>
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
